<template>
	<v-container>
		<p>
			The variable is scored on a scale from 0 to 100, with 100 representing the
			highest level of rights and freedoms. This map represents these scores,
			highlighting the state of human rights across 177 countries. It captures
			the extent to which people are free from government torture, political
			killings, and forced labor. It also evaluates the extent to which
			individuals can exercise their property rights and enjoy fundamental
			freedoms, including the freedom to move, practice religion, express
			opinions, and associate with others.
		</p>
		<p style="font-weight: bold;">Source: V-Dem (2024) - processed by Our World in Data.</p>
		<v-card>
			<iframe
				title="Human Rights in the World"
				aria-label="Map"
				id="datawrapper-chart-RAZRx"
				src="https://datawrapper.dwcdn.net/RAZRx/1/"
				scrolling="no"
				frameborder="0"
				style="width: 0; min-width: 100% !important; border: none;"
				height="441"
				data-external="1"
			>
			</iframe>
		</v-card>
	</v-container>
</template>

<script>
export default {
	mounted() {
		// Function to dynamically load external script
		const loadScript = (src, callback) => {
			const script = document.createElement("script")
			script.src = src
			script.onload = callback
			document.head.appendChild(script)
		}

		// Load the Datawrapper events script
		loadScript("https://static.dwcdn.net/js/events.js", () => {
			// Ensure the `datawrapper` object is available
			if (window.datawrapper) {
				window.datawrapper.on("region.click", (event) => {
					console.log(event.chartId, event.data)
				})
			}
		})

		// Handle iframe resizing
		const iframe = document.getElementById("datawrapper-chart-RAZRx")
		iframe.onload = () => {
			window.addEventListener("message", (event) => {
				if (event.data && event.data["datawrapper-height"]) {
					const iframes = document.querySelectorAll("iframe")
					for (const key in event.data["datawrapper-height"]) {
						for (let i = 0; i < iframes.length; i++) {
							if (iframes[i].contentWindow === event.source) {
								iframes[i].style.height =
									event.data["datawrapper-height"][key] + "px"
							}
						}
					}
				}
			})
		}
	},
}
</script>

<style scoped>
/* Add any custom styles here */
</style>
